import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import NumberInput from '@react/react-spectrum/NumberInput'
import Select from '@react/react-spectrum/Select'

import { ScreenPicker } from '../../ScreenPicker'
import SharedSections from './SharedSections'

const ChildScreens = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Grid Items'>
        <ScreenPicker
          screenName={screen?.meta?.name}
          screens={content.list}
          onChange={onChange('list')}
          disabled={disabled}
          multiple
        />
      </FieldLabel>

      <FieldLabel label='Items in Row'>
        <NumberInput
          min={1}
          max={5}
          name='itemsInRow'
          value={content.itemsInRow || 0}
          onChange={onChange('itemsInRow')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Display items as'>
        <Select
          options={[
            { label: 'Tile', value: 'ClickableImageText' },
            { label: 'Article Summary', value: 'ArticleSummary' },
          ]}
          value={content.itemRenderer || 'ClickableImageText'}
          onChange={onChange('itemRenderer')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

export default [{ label: 'Child Screens', content: ChildScreens }, ...SharedSections]
